module.exports = __webpack_public_path__ + "static/media/no-Image-available.ae6dd4fa.jpg";